import { useEffect, useState } from 'react'
import GetUrls from 'ts/enums/Url'
import { ProductCategory } from 'ts/types'
import useModalStore from 'store/modal'
import { Input, CheckBoxToggle } from 'components/ui'
import useModalForm from 'hooks/useModalForm'

const ProductCategoryAddPage = () => {
const Url = GetUrls();

  const params = useModalStore((state) => state.params) as ProductCategory
  const { ModalForm, form } = useModalForm()
  const [isActive, setIsActive] = useState<boolean>(true);

  const { setValue, register } = form

  useEffect(() => {
    if(params) {
      setValue('categoryId', params.categoryId)
      setIsActive(params.isActive);
    }
  }, [params, setValue])

  const handleToggleActive = (isChecked: boolean) => {
    setIsActive(isChecked);
  }

  return (
    <ModalForm
      config={{ url: params ? Url.updateCategory : Url.postCategory, method: params ? 'PUT' : 'POST' }}
      title={`${params ? 'Edit ' : 'Create ' }Category`}
      description='Create or edit a Category'
    >
      <CheckBoxToggle 
          label="Active" 
          defaultChecked={isActive} 
          onToggle={handleToggleActive}
        />
        <Input
            label="Active" 
            className='hidden'
            {...register("isActive", { value : isActive ? 1 : 0 })}
        />
      <Input
        defaultValue={params?.categoryName}
        label="Category Name"
        {...register('categoryName', { required: true })}
      />
      {/* <Select
        defaultValue={params?.department || ''}
        label="Department"
        options={productCategoryTypes}
        {...register('department', { required: true })}
      /> */}
    </ModalForm>
  )
}

export default ProductCategoryAddPage
